/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message-popup[_ngcontent-%COMP%]{left:calc(50% - 14px)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-placeholder.component.scss.shim.ngstyle.js.pre-build-optimizer.js